import styled, { css } from 'styled-components'
import { ReactComponent as PlusIcon } from 'presentation/assets/icons/plus.svg'
import { ReactComponent as TrashIcon } from 'presentation/assets/icons/trashIcon.svg'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`

export const Inputs = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  margin-bottom: 20px;
`

export const Providers = styled.div`
  position: relative;

  svg:hover {
    path {
      fill: ${({ theme }) => theme.colors.secondary};
    }
  }

  path {
    fill: ${({ theme }) => theme.colors.primary};
    transition: 0.3s;
  }
`

export const RemoveProviderIcon = styled(TrashIcon)`
  top: 0;
  right: 0;
  cursor: pointer;
  align-self: center;
`

export const AddProviderIcon = styled(PlusIcon)`
  padding: 1px;
  margin-right: 8px;
`

export const AddProviderWrapper = styled.div`
  cursor: pointer;
  top: 120%;
  left: 50%;
  display: flex;
  align-items: center;
  place-content: center;
  p {
    transition: 0.3s;
  }
  &:hover {
    p {
      color: ${({ theme }) => theme.colors.secondary};
    }

    svg {
      path {
        fill: ${({ theme }) => theme.colors.secondary};
      }
    }
  }

  p {
    font-size: ${({ theme }) => theme.font.sizes.xsmall};
    font-weight: ${({ theme }) => theme.font.semiBold};
    color: ${({ theme }) => theme.colors.primary};
  }
`

export const QuantityContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 0px 20px;

  input {
    width: 58px;
    padding: 0;
    margin: 0;
    text-align: center;
  }

  h5 {
    margin-right: 10px;
  }
`

export const Title = styled.h5`
  ${({ theme }) => css`
    font-size: ${theme.font.sizes.medium};
    font-weight: 400;
    color: ${theme.colors.gray};
    cursor: pointer;
  `}
`
